import Vue from 'vue';
import App from './App.vue';
import router from './router';
import VueI18n from 'vue-i18n';
import messages from './locales';

Vue.config.productionTip = false;

Vue.use(VueI18n);

const i18n = new VueI18n({
    locale: 'tr',
    messages,
});

new Vue({
    router,
    i18n,
    render: h => h(App),
}).$mount('#app');